import React from "react";
import { useDispatch } from "react-redux";
import { showDeleteConfirm } from "../../../../helpers/confirmModal";
import { TipoButtonConstants } from "../../../../types/typesConstants";
import { Space } from "antd";
import { ButtonUi } from "../../../ui/ButtonUi";
import { TableUi } from "../../../ui/TableUi";
import {
  rutaProduccionSetActive,
  rutaProduccionStartDelete,
  showFormRutaProduccion,
} from "../../../../actions/produccion";
const columns = (acciones) => {
  const { handleEditar, handleEliminar } = acciones;
  return [
    {
      title: "#",
      dataIndex: "nro",
      key: "nro",
      render: (text, record, index) => <>{index + 1}</>,
    },
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
    },
    {
      title: "",
      dataIndex: "opciones",
      key: "opciones",
      render: (text, record) => (
        <Space wrap>
          <ButtonUi
            key="Editar"
            displayText={false}
            typeUi={TipoButtonConstants.EditarTable}
            onClick={() => handleEditar(record)}
          />
          <ButtonUi
            key="Eliminar"
            displayText={false}
            typeUi={TipoButtonConstants.EliminarTable}
            onClick={() => handleEliminar(record)}
          />
        </Space>
      ),
    },
  ];
};
export const RutaProduccionTable = ({ data }) => {
  const dispatch = useDispatch();
  const handleEditar = (record) => {
    dispatch(rutaProduccionSetActive(record));
    dispatch(showFormRutaProduccion(true));
  };
  const handleEliminar = (record) => {
    showDeleteConfirm(
      "¿Está seguro de eliminar la ruta de programación?",
      record.nombre,
      (isConfirmed) => {
        if (isConfirmed) {
          dispatch(rutaProduccionStartDelete(record));
        }
      }
    );
  };
  return (
    <TableUi
      data={data}
      columns={columns({ handleEditar, handleEliminar })}
      rowKey="id"
      size="small"
    />
  );
};
